function updateControls() {
  var max_scroll = Math.round($('.table_price_container table').outerWidth() - $('.table_price_container').outerWidth());
  if (max_scroll == 0) {
    $('.table-left-control').hide();
    $('.table-right-control').hide();
  }
  else if ($('.table-price-chalet').scrollLeft() <= 8) {
    $('.table-left-control').hide();
    $('.table-right-control').show();
  }
  else if ($('.table-price-chalet').scrollLeft() >= (max_scroll - 8)) {
    $('.table-right-control').hide();
    $('.table-left-control').show();
  }
  else {
    $('.table-left-control').show();
    $('.table-right-control').show();
  }
}

updateControls();

$('.table-left-control').click(function () {
  $('.table-price-chalet').animate({scrollLeft: $('.table-price-chalet').scrollLeft() - 85}, 300);
  setTimeout(updateControls, 301);
});
$('.table-right-control').click(function () {
  $('.table-price-chalet').animate({scrollLeft: $('.table-price-chalet').scrollLeft() + 85}, 300);
  setTimeout(updateControls, 301);
});

$(window).resize(function () {
  updateControls();
});